import { MAX_AGENT_INSTRUCTION_LENGTH } from '@/_data/agentChat';
import type { AgentThreadView } from '@/_contract/agentChat';

export function agentSceneCaption(state: {
    view: AgentThreadView | null; loading: boolean; sending: boolean; reconnecting?: boolean; error?: string;
}): { text: string; status: string; streaming: boolean } | undefined {
    const view = state.view;
    if (!view || state.loading) return undefined;
    const lastUser = view.entries.findLastIndex(entry => entry.role === 'user');
    if (lastUser < 0) return undefined;
    const prompt = view.entries[lastUser].content;
    const response = view.entries.slice(lastUser + 1).filter(entry => entry.role === 'agent')
        .map(entry => view.transport === 'ahp' ? entry.responseContent ?? entry.speechContent ?? '' : entry.content).filter(Boolean).join('\n');
    const status = state.reconnecting ? 'Reconnecting to Forge. Press Y to inspect the connection.'
        : state.error ?? view.error ?? (view.plans?.some(plan => plan.pending) ? 'Plan ready. Press Y > Sessions / requests to finish planning; no implementation approved.'
            : view.approvals?.length ? 'Approval required. Press Y > Sessions / requests to inspect the command. No completed answer yet.'
                : view.inputs?.length || view.status === 'input' ? 'The Agent needs your answer. Press Y > Sessions / requests.'
                    : state.sending ? 'Sending your prompt...'
                        : view.status === 'working' || view.status === 'thinking' || view.status === 'queued' ? 'Agent working...'
                            : view.status === 'error' ? 'The Agent turn failed. Press Y to inspect the error.'
                                : !response ? 'No answer was produced. Press Y to inspect the conversation.' : '');
    return { text: [`You:\n${prompt}`, response ? `Agent:\n${response}` : ''].filter(Boolean).join('\n\n'), status,
        streaming: !!view.activeTurnId && ['working', 'thinking', 'queued'].includes(view.status)
            && !view.approvals?.length && !view.inputs?.length && !view.plans?.some(plan => plan.pending) };
}

export function chatTextPages(text: string, columns = 52, rows = 8): string[] {
    const lines = text.split('\n').flatMap(line => {
        const chars = Array.from(line);
        const wrapped: string[] = [];
        for (let i = 0; i < chars.length; i += columns) wrapped.push(chars.slice(i, i + columns).join(''));
        return wrapped.length ? wrapped : [''];
    });
    const pages: string[] = [];
    for (let i = 0; i < lines.length; i += rows) pages.push(lines.slice(i, i + rows).join('\n'));
    return pages;
}

export function editChatDraft(draft: string, key: string): string {
    if (key === 'Backspace') return Array.from(draft).slice(0, -1).join('');
    if (key === 'Clear') return '';
    return (draft + (key === 'Enter' ? '\n' : key)).slice(0, MAX_AGENT_INSTRUCTION_LENGTH);
}

export const CHAT_KEY_ROWS = [
    '1234567890',
    'qwertyuiop',
    'asdfghjkl',
    'zxcvbnm^~',
    '.,?!-_:;\'"',
    '()[]{}<>/\\',
    '=+*@#$%&|`',
];
export function adjustXrHudDistance(distance: number, axis: number, delta: number): number {
    if (Math.abs(axis) <= 0.2) return distance;
    return Math.min(5, Math.max(1, distance - axis * Math.max(0, Math.min(delta, 0.1))));
}
